import arrayMutators from 'final-form-arrays';
import { Form } from 'react-final-form';
import { Dispatch, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IPassportGroupForm } from '../interfaces/IPassportGroupForm';
import { PassportGroupRenderForm } from './PassportGroupRenderForm';
import { passportGroupFormToRequest } from '../common/passportGroupFormToRequest';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import {
  passportGroupCreateAction,
  passportGroupSetCreateSuccessAction,
} from '../../MainModule/actions/passportGroupActions';
import { passportGroupCreateSuccessSelector } from '../../MainModule/selectors/passportGroupSelector';
import { passportGroupFormValidate } from '../common/passportGroupFormValidate';
import { PassportGroupTypeEnum } from '../../../APIPackage/PassportGroupsModule/enums/PassportGroupTypeEnum';

interface IPassportGroupFormProps {
  onGroupCreated: () => void;
  onCancelCreate: () => void;
  groupType: PassportGroupTypeEnum;
}

export const PassportGroupForm = ({ onGroupCreated, onCancelCreate, groupType }: IPassportGroupFormProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isCreateSuccess = useSelector(passportGroupCreateSuccessSelector);

  const handleSubmit = useCallback(
    (values: IPassportGroupForm) => {
      const data = passportGroupFormToRequest(values, groupType);

      dispatch(passportGroupCreateAction(data));
    },
    [dispatch, groupType],
  );

  useEffect(() => {
    if (isCreateSuccess) {
      dispatch(passportGroupSetCreateSuccessAction(false));
      onGroupCreated();
    }
  }, [isCreateSuccess, onGroupCreated, dispatch]);

  return (
    <Form<IPassportGroupForm>
      render={props => <PassportGroupRenderForm {...props} onCancelCreate={onCancelCreate} groupType={groupType} />}
      mutators={{ ...arrayMutators }}
      onSubmit={handleSubmit}
      validate={passportGroupFormValidate}
    />
  );
};
